export default {
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      search: '',
      items: []
    };
  },

  computed: {
    listeners() {
      return Object.assign({}, this.$listeners, {
        change: [this.clearSearch, this.emitter],
        'click:clear': this.clearFilter
      });
    }
  },

  methods: {
    clearSearch() {
      this.search = '';
    },

    clearFilter() {
      this.emitter(this.multiple ? [] : '');
    },

    emitter(data) {
      this.$emit('input', data);
      this.$emit('change', data);
    }
  }
};
